import { RESERVATIONS_BASE_KEY } from '@iheartjane/data-access';
import { Box } from '@iheartjane/reefer';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { userQueryKeys } from '@jane/shared/data-access';
import { useEcommApp } from '@jane/shared/providers';
import { monolithPaths as paths } from '@jane/shared/util';

import { useCustomerDispatch } from '../../customer/dispatch';
import { closeModal } from '../../customer/redux/application';
import { logOut, selectCustomer } from '../../customer/redux/customer';
import { useCustomerSelector } from '../../customer/selectors';
import { LogoutForm } from './form';
import { LogoutModal } from './modal';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const customer = useCustomerSelector(selectCustomer);
  const hasUser = Boolean(customer.id);
  const { isEmbed } = useEcommApp();

  const dispatch = useCustomerDispatch();

  const logout = useCallback(() => {
    if (queryClient) {
      dispatch(
        logOut(() => {
          queryClient.invalidateQueries({ queryKey: userQueryKeys.janeUser() });
          queryClient.refetchQueries(userQueryKeys.janeUser()).then(() =>
            queryClient.invalidateQueries({
              queryKey: [RESERVATIONS_BASE_KEY],
            })
          );
        })
      );
    } else {
      dispatch(logOut());
    }
  }, []);

  useEffect(() => {
    if (hasUser) {
      return;
    }

    if (isEmbed) {
      navigate(paths.embeddedLogin(), { replace: true });
    }

    dispatch(closeModal());
    navigate(paths.root(), { replace: true });
  }, [hasUser, isEmbed]);

  return logout;
};

export const Logout = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  const { isEmbed } = useEcommApp();

  if (isEmbed) {
    return (
      <Box mx="auto" maxWidth={360} pt={24}>
        <LogoutForm
          onCancel={() => navigate(paths.embeddedMenu())}
          onLogout={logout}
          embeddedMode
        />
      </Box>
    );
  }

  return <LogoutModal onLogout={logout} />;
};
